import { create } from 'zustand';
import type { CalendarView } from '@ext-bookmark/shared/types';
import type { Holiday } from '../services/todo/holidays';

interface CalendarState {
  currentDate: Date;
  selectedDate: Date | null;
  view: CalendarView;
  selectedGroupIds: Set<string>;
  holidays: Map<string, Holiday>;
  
  // Actions
  setCurrentDate: (date: Date) => void;
  setSelectedDate: (date: Date | null) => void;
  setView: (view: CalendarView) => void;
  toggleGroup: (groupId: string) => void;
  setSelectedGroupIds: (groupIds: Set<string>) => void;
  setHolidays: (holidays: Map<string, Holiday>) => void;
}

export const useCalendarStore = create<CalendarState>((set) => ({
  currentDate: new Date(),
  selectedDate: new Date(),
  view: 'month',
  selectedGroupIds: new Set(),
  holidays: new Map(),
  
  setCurrentDate: (date) => set({ currentDate: date }),
  setSelectedDate: (date) => set({ selectedDate: date }),
  setView: (view) => set({ view }),
  toggleGroup: (groupId) => set((state) => {
    const newSet = new Set(state.selectedGroupIds);
    if (newSet.has(groupId)) {
      newSet.delete(groupId);
    } else {
      newSet.add(groupId);
    }
    return { selectedGroupIds: newSet };
  }),
  setSelectedGroupIds: (groupIds) => set({ selectedGroupIds: groupIds }),
  setHolidays: (holidays) => set({ holidays }),
}));
